export default __webpack_public_path__ + "static/media/unlock-opportunities.341a2716.svg";